import { createContext } from 'react'

// Context that lets a Combobox portal itself into the nearest Dialog content
// element instead of `document.body`. Lives in its own tiny module so that
// importing it from `dialog.tsx` does not pull in the heavy @base-ui Combobox
// chunk (≈30 KB gz of esm/combobox/* files) into the main entry bundle.
export const ComboboxPortalContainerContext = createContext<HTMLElement | null>(null)
